var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"reference-link",on:{"click":function($event){$event.preventDefault();return _vm.$modal.show('reference-modal')}}},[_vm._v("Использованные материалы")])}
var staticRenderFns = []

export { render, staticRenderFns }